!function($, window, document) {
    const $win = $(window), $doc = $(document);
    let yDown, isBreakpointMobile = window.matchMedia("(max-width: 767px)").matches, blocked = !1, blockTimeout = null, prevDeltaY = 0;
    function applyColumnTransforms($slides, currentSlide) {
        requestAnimationFrame((function() {
            $slides.each((function(index) {
                const $slide = $(this), $cols = $slide.find(".slider__col"), isReversed = $slide.find(".grid--reversed").length > 0;
                index === currentSlide ? $cols.css("transform", "translateY(0)") : index < currentSlide ? isReversed ? ($cols.eq(0).css("transform", "translateY(-100%)"), 
                $cols.eq(1).css("transform", "translateY(100%)")) : ($cols.eq(0).css("transform", "translateY(100%)"), 
                $cols.eq(1).css("transform", "translateY(-100%)")) : isReversed ? ($cols.eq(0).css("transform", "translateY(100%)"), 
                $cols.eq(1).css("transform", "translateY(-100%)")) : ($cols.eq(0).css("transform", "translateY(-100%)"), 
                $cols.eq(1).css("transform", "translateY(100%)"));
            }));
        }));
    }
    $doc.on("click", ".js-slide-to-end", (function(e) {
        if (e.preventDefault(), isBreakpointMobile) {
            const $enquireSection = $("#enquire");
            return $(".slider__slides").addClass("disable-snapping"), void ($enquireSection.length && $("html, body, .slider__slides").animate({
                scrollTop: $enquireSection.offset().top
            }, 700, (function() {
                $(".slider__slides").removeClass("disable-snapping");
            })));
        }
        const $slider = $(".js-slider-page .slick-slider");
        if ($slider.length && $slider.hasClass("slick-initialized")) {
            const slideCount = $slider.slick("getSlick").slideCount;
            $slider.slick("slickGoTo", slideCount - 1);
        }
    })), function initSliderPage() {
        const $slider = $(".js-slider-page");
        isBreakpointMobile || $slider.each((function() {
            const $currentSlider = $(this), $slidesContainer = $currentSlider.find(".slider__slides");
            $slidesContainer.on("init", (function(event, slick) {
                $currentSlider.removeClass("is-not-loaded"), applyColumnTransforms($(slick.$slides), 0), 
                "complete" === document.readyState ? $slidesContainer.addClass("is-initialized") : $(window).on("load", (function() {
                    $slidesContainer.addClass("is-initialized");
                }));
            })), $slidesContainer.on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                const videoPlayer = $(".slider-page").find(".media").filter(((index, el) => el.plyr));
                void 0 !== videoPlayer[0] && (videoPlayer[0].plyr.pause(), $(videoPlayer).find(".js-play-btn").removeClass("is-played")), 
                applyColumnTransforms($(slick.$slides), nextSlide);
            })), $slidesContainer.on("afterChange", (function() {
                $(".slick-slide").removeClass("is-current"), $(".slick-current").addClass("is-current");
            })), $currentSlider.find(".slick-initialized").length || $slidesContainer.slick({
                fade: !0,
                infinite: !1,
                arrows: !1,
                dots: !1,
                swipe: !1,
                lazyLoad: !1,
                speed: 700
            });
        }));
    }(), $win.on("mousewheel DOMMouseScroll wheel", (function handleMouseWheelSliderChange(e) {
        let deltaX = e.originalEvent.deltaX, deltaY = e.originalEvent.deltaY;
        const $sliderPage = $(".js-slider-page .slider__slides");
        e.stopPropagation(), deltaY && $sliderPage.hasClass("slick-slider") && (clearTimeout(blockTimeout), 
        blockTimeout = setTimeout((function() {
            blocked = !1;
        }), 100), deltaX < 1 && deltaX > -1 && (deltaY > 10 && deltaY > prevDeltaY || deltaY < -10 && deltaY < prevDeltaY || !blocked) && (blocked = !0, 
        prevDeltaY = deltaY, deltaY > 0 ? $sliderPage.slick("slickNext") : $sliderPage.slick("slickPrev")));
    })), document.addEventListener("touchstart", (function handleTouchStart(e) {
        const firstTouch = function getInitialTouches(e) {
            return e.touches || e.originalEvent.touches;
        }(e)[0];
        yDown = firstTouch.clientY;
    }), !1), document.addEventListener("touchmove", (function handleTouchMove(e) {
        const $sliderPage = $(".js-slider-page .slider__slides");
        if (!yDown) return;
        const yUp = e.touches[0].clientY, yDiff = yDown - yUp;
        $sliderPage.hasClass("slick-initialized") && (yDiff > 0 ? $sliderPage.slick("slickNext") : $sliderPage.slick("slickPrev"), 
        yDown = null);
    }), !1);
}(jQuery, window, document);